import _ from 'lodash';
import {
  useState,
  useEffect,
} from 'react';
import {
  qalBoxSearchMediaTag,
} from '../../services/mp-cf-api-service';

const mediaTagSearch = () => {
  const [ responseData, setResponseData ] = useState({ });
  const [ updateData, setOperationData ] = useState(null);
  const {
    searchConfig,
    onOperationComplete,
  } = updateData || {};

  const searchMediaItems = async () => {
    try {
      console.log(`QalBox searching media tags ...`);
      setResponseData({
        isLoading: true,
        isError: false,
      });

      const mediaTagItemsApiResp = await qalBoxSearchMediaTag({
        data: searchConfig,
      });

      console.log(mediaTagItemsApiResp);

      const responseData = _.get(mediaTagItemsApiResp, 'data', {});

      let errorMsg = null;
      let isError = false;

      if(responseData.success) {
        console.log('QalBox search media tag items Success!!');
      } else {
        console.log('QalBox search media tag items Failed!!');
        errorMsg = `Failed to search QalBox media tag items.`;
        isError = true;
      }

      setResponseData({
        isLoading: false,
        isError,
        errorMsg,
        data: responseData.payload,
      });

      if(onOperationComplete) {
        onOperationComplete({
          isError,
          errorMsg,
          data: responseData.payload,
        });
      }
    } catch (err) {
      console.log('Something went wrong while searching QalBox media items. ', err);
      const errorMsg = `Error occurred while searching QalBox media items.`;
      setResponseData({
        isLoading: false,
        isError: true,
        errorMsg,
        data: null,
      });
      if(onOperationComplete) {
        onOperationComplete({
          isError: true,
          errorMsg,
          data: null,
        });
      }
    }
  };

  useEffect( () => {
    if(!_.isEmpty(updateData)) {
      searchMediaItems();
    }
  }, [ updateData ]);

  return [
    responseData,
    setOperationData,
  ];
};

export default mediaTagSearch;
